import { SlideComponentStrokeWriting } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentStrokeWritingCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentStrokeWriting {
        return {
            id: id,
            pos: {
                x: 0,
                y: 0,
            },
            size: {
                width: 400,
                height: 400,
            },
            type: 'strokeWriting',
            content: {
                code: '',
                locale: '',
                character: '',
            },
        };
    }
}
